<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">ACKNOWLEDGEMENTS</p>
<p class="subhead"><i>Braeden Paul Would Like to Thank</i></p>
<p class="noindent1">My father, Robby Paul, and grandfather Bobby Paul for introducing me to this big part of my life called bluegrass music.</p>
<p class="indent">My mother, Michelle Hammock, for constantly seeing my potential and making sure others saw it as well.</p>
<p class="indent">David, Diana, Zack, Adam, Lindsay, Jared and all of my family for their love and support.</p>
<p class="indent">John Lawless and Terry Herd of <i>Bluegrass Today</i> for giving me a chance to exercise my writing muscle on a weekly basis.</p>
<p class="indent">The Southwest Bluegrass Club for their tireless promotion of bluegrass music and their support of my endeavors.</p>
<p class="indent">All of the individuals who gave their time and resources for the book.</p>
<p class="indent">Jeff Campbell for being a great collaborator and guiding me through the book writing process.</p>
<p class="subhead"><i>Jeff Campbell Would Like to Thank</i></p>
<p class="noindent1">My wife for her love, encouragement and support.</p>
<p class="indent">Alan Tompkins and the Bluegrass Heritage Foundation for treating us like family.</p>
<p class="indent">Alan Munde for being an encouraging mentor and writing the foreword for this book.</p>
<p class="indent">The Central Texas Bluegrass Association for its enthusiastic support.</p>
<p class="indent">Rick Gardner and Liz Patton for their wonderful photos.</p>
<p class="indent">All of the talented musicians who gave their time to be interviewed for this book.</p>
<p class="indent">My coauthor, Braeden Paul, for agreeing to take on the challenge of writing a book, one more time!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?17783f00